const e = {
  name: "Filter",
  dimensions: { width: 24, height: 24 },
  content: `
    <g>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M2 3C2 2.44772 2.44772 2 3 2H21C21.5523 2 22 2.44772 22 3V6.17157C22 6.96722 21.6839 7.73028 21.1213 8.29289L15 14.4142V17C15 17.2652 14.8946 17.5196 14.7071 17.7071L10.7071 21.7071C10.4211 21.9931 9.99099 22.0787 9.61732 21.9239C9.24364 21.7691 9 21.4045 9 21V14.4142L2.87868 8.29289C2.31607 7.73028 2 6.96722 2 6.17157V3ZM4 4V6.17157C4 6.43679 4.10536 6.69114 4.29289 6.87868L10.7071 13.2929C10.8946 13.4804 11 13.7348 11 14V18.5858L13 16.5858V14C13 13.7348 13.1054 13.4804 13.2929 13.2929L19.7071 6.87868C19.8946 6.69114 20 6.43679 20 6.17157V4H4Z" fill="currentColor"/>
    </g>
    `
};
export {
  e as Filter
};
